.dealCardContainer {
  display: flex;
}

.dealCard {
  position: relative;
  min-width: 39vw;
  max-width: 39vw;
  height: 330px;
  display: flex;
  flex-direction: column;
  border-radius: 0.5rem;
  margin: 2rem 1rem 2rem 0;
  background-color: var(--deal-card-bg-color);
  transition: all 0.3s ease;
}

.dealCard:hover {
  transform: var(--scale-card);
}

.netIRRBackdropContainer {
  display: flex;
  flex-direction: column;
}

.netIRRBackdrop {
  display: flex;
  flex-direction: column;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  justify-content: center;
  padding: 0.5rem;
  margin-top: 80%;
  background-color: var(--deal-attributes-INR-color);
  border-left: 1px solid var(--deal-attributes-INR-color);
  border-right: 0;
}

.backgroundImage {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0.03;
  z-index: -1;
}

.debt {
  border: 1px solid var(--green-secondary-color) !important;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
}

.debt:hover {
  /* background-color: var(--green-secondary-hvr-color); */
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,
    rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
}

.std {
  border: 1px solid var(--green-primary-color) !important;
  /* background-color: var(--green-primary-bg-color);     */
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
}

.std:hover {
  /* background-color: var(--green-primary-hvr-color); */
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,
    rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
}

.dealCardContent {
  display: flex;
  height: 100%;
  justify-content: space-around;
  flex-direction: column;
  z-index: 1;
}

.logoWrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0.1rem 0.5rem 0 0.5rem;
}

.dealLogo {
  flex: 1.5;
  margin-top: -0.8rem;
  object-fit: contain;
  width: 5rem;
  height: 3.5rem;
  transition: all 0.3s ease;
}

.progressBar {
  padding: 0 1.5rem;
}

.progressText {
  display: flex;
  justify-content: space-between;
}

@media only screen and (max-width: 550px) {
  .dealCard {
    height: 270px;
  }
}

@media (min-width: 1801px) {
  .dealCard {
    height: 420px;
  }
}
